// root '../../../';

// dependencies
import { Child } from 'pym.js';
// import { select } from 'd3-selection';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import { stylePremium } from './utils/helpers';
// import config from './config';
// import graphic from './graphic';

// styles
import './styles/index.scss';
import './styles/graphic.scss';

/* develblock:start */
import meta from './data/meta.json';

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });

window.onload = () => {
  // necessary evil for right now

  const { pymChild } = window;
  // delay the initial resizing to give Twitter time to render tweets
  setTimeout(() => { pymChild.sendHeight(); }, 250);
  window.dispatchEvent(new Event('resize'));
};


const CNNPolitics = true;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

function draw() {
  window.dispatchEvent(new Event('resize'));
}
